var map = {
	"./clean.svg": 96120,
	"./delete.svg": 42096,
	"./download.svg": 40757,
	"./icon_down.svg": 20289,
	"./icon_next.svg": 8722,
	"./icon_preview.svg": 74107,
	"./link.svg": 6245,
	"./pop-quiz-v2_audio.svg": 44082,
	"./pop-quiz-v2_filter.svg": 8394,
	"./pop-quiz-v2_image.svg": 99555,
	"./pop-quiz-v2_lock.svg": 3265,
	"./pop-quiz-v2_text-box.svg": 54365,
	"./pop-quiz-v2_text.svg": 95497,
	"./pop-quiz-v2_video.svg": 78373,
	"./preview.svg": 86335,
	"./refresh.svg": 21426,
	"./rotate.svg": 97088,
	"./upload.svg": 53314,
	"./展开全部.svg": 36658,
	"./快捷下发.svg": 29939,
	"./时间.svg": 76267,
	"./显示文本.svg": 76788,
	"./正确.svg": 75798,
	"./画笔.svg": 93220,
	"./答题器.svg": 83991,
	"./统计.svg": 75277,
	"./重新检测.svg": 60865,
	"./错误.svg": 60833,
	"./隐藏文本.svg": 29731
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 66474;